import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

import { Color } from './color';

@Component({
  selector: 'pcs-color-item',
  template: `
    <span [ngClass]="classes()"></span>
  `,
  styleUrls: ['./color-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorItemComponent {
  @Input() color: Color;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() colorSelected = new EventEmitter<Color>();

  @HostListener('click')
  onClick() {
    if (!this.disabled) {
      this.colorSelected.emit(this.color);
    }
  }

  classes() {
    return {
      selected: this.selected,
      [this.color.value]: true,
      disabled: this.disabled
    };
  }
}
